export default class {
	constructor() {
		this.data = [];
		this.textEncoder = new TextEncoder('utf-8');
		this.textDecoder = new TextDecoder('utf-8');
	}

	appendBytes(bytes) {
		this.data = this.data.concat(bytes);
	}

	appendString(str) {
		this.appendBytes(Array.from(this.textEncoder.encode(str)));
	}

	toString() {
		const view = new Uint8Array(this.data);
		return this.textDecoder.decode(view);
	}

	getArray() {
		return new Uint8Array(this.data);
	}

	getBytes() {
		return Array.from(this.getArray());
	}
}
